import React from "react";
import ContactForm from "../Components/ContactForm/ContactForm";
import { Phone, Envelope } from "react-bootstrap-icons";
import "./Home.css";
import Header from "../Images/Header.jpg";

export default function Entertainment() {
  return (
    <div className="Home">
      <div className="lander">
        <div className="body">
          {/* <h1 className="main">Helmut Fricker</h1> */}

          <div className="info">
            <h2 className="">World Class Musician and Entertainer</h2>
            {/* <Header /> */}
            <img src={Header} alt="Header" />
            <p className="text">
              Available for public and private performances. You can see
              Helmut's public performances listed below including my appearances
              on the Beaver Creek Plaza throughout the winter. More details
              below.
              <br />
              <span className="strong">
                Just listen for the famous Helmut Fricker yodel!
              </span>
            </p>
            <hr className="line" />
            <h2 className="title">Public Performances</h2>
            <div className="performanceList">
              <h3 className="title">Winter 2025/2026 on the Plaza at Beaver Creek:</h3>
              <h5>Located at the Northface tent by the Ice Rink (top of the escalator by the Vilar Center) </h5>
              <h5>Please note there are no performances on Dec 25th and 31st, and Feb 21st</h5>
              <br/>
{/* Upload everything in the build folder, but not the build folder itself to s3 and then do a cloudfront invaldiation */}
              <h3>
                <h3 class="date"> Every week Wednesday, Thursday and Saturday 1pm - 3pm</h3>
                <h4 className="text">December 13 ,2025 through March 28, 2026</h4>
                <h4>Extra Dates Added: March 31st & April 2nd 2026</h4>
                
                <br />
              </h3>
              
              {/* <h3 className="title">Beaver Creek Oktoberfest:</h3>

              <h3>
                <h3 class="date"> August 29, 2025</h3>
                <h4>Opening Ceremony: 4pm-4:30pm</h4>
                <br />
                <h3 class="date"> August 30, 2025</h3>
                <h4>1pm-2pm and 4pm-5pm</h4>
                <br />
                <h3 class="date"> August 31, 2025</h3>
                <h4>1:30pm-2:30pm</h4>
                
              </h3>

              <h3 className="title">Eagle Chamber & Umbrella Roofing Biztoberfest:</h3>
              <h5>Brush Creek Pavillion in Eagle Ranch, Eagle, CO</h5>
                <h3>
                <h3 class="date"> September 4, 2025</h3>
                <h4>4pm-7pm</h4>
              </h3>

              <h3 className="title">Vail Oktoberfest: Lionshead</h3>

              <h3>
                <h3 class="date"> September 5, 2025</h3>
                <h4>Main Stage: 12:30pm-1:45pm</h4>
                <br />
                <h3 class="date"> September 6, 2025</h3>
                <h4>Main Stage: 1:45pm-2:45pm</h4>
                <br />
                <h3 class="date"> September 7, 2025</h3>
                <h4>Main Stage: 2pm-2:45pm</h4>
                
              </h3>

              <h3 className="title">Vail Oktoberfest: Vail Village</h3>

              <h3>
                <h3 class="date"> September 12, 2025</h3>
                <h4>Main Stage: 12:30pm-3pm</h4>
                <br />
                <h3 class="date"> September 13, 2025</h3>
                <h4>Main Stage: 12pm-1pm</h4>
                <h4>River Stage 2:30pm-3:30pm</h4>
                <h4>Main Stage: 6pm-7pm</h4>
                <br />
                <h3 class="date"> September 14, 2025</h3>
                <h4>Main Stage: 2pm-2:45pm</h4>
                <h4>River Stage: 3:45pm-5pm</h4>
                
              </h3> */}

              <h3 className="title">Sarah's Lounge at the Christiana Lodge in Vail:</h3>
              <h3 class="date">
                Join Helmut every Friday Night from 4:30 - 6:30 throughout the Vail ski season                
              </h3>

              <h4 className="text">Starting December 12, 2025</h4>
              <h4>Extra Dates Added: April 3rd & 10th 2026</h4>
              
            </div>


            <hr className="line" />
            <h2 className="title">Performance Inquiries</h2>
            <h4 className="text subtitle">
              Contact Helmut directly for pricing and schedule
            </h4>
            <p>
              <Phone /> (970) 471-2779
            </p>
            <p>
              <Envelope /> helmutfricker@gmail.com
            </p>
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
}
